module.exports = __webpack_public_path__ + "r-v3/img/more_vertical.ff560be2.svg";